import { ThemeProvider } from "react-bootstrap";
import { JSX, useState } from "react";
import { useTranslation } from "react-i18next";
import { IRunOptions, Paragraph, TextRun } from "docx";
import i18n from "i18next";

export const rtlLangs = new Set<string>(["ar", "he", "fa"]);

export function BSRTLThemeProvider(props: { children: JSX.Element }) {
  const { i18n } = useTranslation();
  const [isRTL, setIsRTL] = useState(rtlLangs.has(i18n.language));

  i18n.on("languageChanged", (lng) => {
    const docEl = document.documentElement;
    docEl.setAttribute("lang", lng);

    const code = lng.substring(0, 2).toLowerCase();
    if (rtlLangs.has(code)) {
      docEl.setAttribute("dir", "rtl");
      setIsRTL(true);
    } else {
      docEl.setAttribute("dir", "ltr");
      setIsRTL(false);
    }
  });

  return <ThemeProvider dir={isRTL ? "rtl" : "ltr"}>{props.children}</ThemeProvider>;
}

const arabicRegex = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
const hebrewRegex = /[\u0590-\u05FF]/;
export function isRTL(text: string): boolean {
  return arabicRegex.test(text) || hebrewRegex.test(text);
}

export function createSmartParagraph(text: string, options = {}): Paragraph {
  const isLocaleRTL = rtlLangs.has(i18n.language);

  return new Paragraph({
    bidirectional: isLocaleRTL,
    ...options,
    children: [createSmartTextRun(text)],
  });
}

export function createSmartTextRun(text: string, options?: IRunOptions) {
  return new TextRun({ text: text, rightToLeft: isRTL(text), ...options });
}
